import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

export default class healthState extends baseState {
	// 位置
	@observable locationList = {};
	getLocationList = (data) => {
		return this.fetch({
			url: apiUrl.HEALTHY_DATA.LOCATION_LIST,
			method: "get",
			setState: (data) => this.locationList = data,
			data,
		});
	};

	// 步数
	@observable stepList = {};
	@action
	setStepList = (data) => (this.stepList = data);
	getStepList = (data) => {
		return this.fetch({
			url: apiUrl.HEALTHY_DATA.STEP_LIST,
			method: "get",
			setState: this.setStepList,
			data,
		});
	};

	// 心率
	@observable heartRateList = {};
	@action
	setHeartRateList = (data) => (this.heartRateList = data);
	getHeartRateList = (data) => {
		return this.fetch({
			url: apiUrl.HEALTHY_DATA.HEART_RATE_LIST,
			method: "get",
			setState: this.setHeartRateList,
			data,
		});
	};

	// 血压
	@observable bloodPressureList = {};
	@action
	setBloodPressureList = (data) => (this.bloodPressureList = data);
	getBloodPressureList = (data) => {
		return this.fetch({
			url: apiUrl.HEALTHY_DATA.BLOOD_PRESSURE_LIST,
			method: "get",
			setState: this.setBloodPressureList,
			data,
		});
	};

	// 血氧
	@observable bloodOxygenList = {};
	@action
	setBloodOxygenList = (data) => (this.bloodOxygenList = data);
	getBloodOxygenList = (data) => {
		return this.fetch({
			url: apiUrl.HEALTHY_DATA.BLOOD_OXYGEN_LIST,
			method: "get",
			setState: this.setBloodOxygenList,
			data,
		});
	};

	// 睡眠
	@observable sleepList = {};
	@action
	setSleepList = (data) => (this.sleepList = data);
	getSleepList = (data) => {
		return this.fetch({
			url: apiUrl.HEALTHY_DATA.SLEEP_LIST,
			method: "get",
			setState: this.setSleepList,
			data,
		});
	};

	// 压力
	@observable pressureList = {};
	@action
	setPressureList = (data) => (this.pressureList = data);
	getPressureList = (data) => {
		return this.fetch({
			url: apiUrl.HEALTHY_DATA.PRESSURE_LIST,
			method: "get",
			setState: this.setPressureList,
			data,
		});
	};

	// 温度
	@observable temperatureList = {};
	@action
	setTemperatureList = (data) => (this.temperatureList = data);
	getTemperatureList = (data) => {
		return this.fetch({
			url: apiUrl.HEALTHY_DATA.TEMPERATURE_LIST,
			method: "get",
			setState: this.setTemperatureList,
			data,
		});
	};

	// 血糖
	@observable bloodSugarList = {};
	@action
	setBloodSugarList = (data) => (this.bloodSugarList = data);
	getBloodSugarList = (data) => {
		return this.fetch({
			url: apiUrl.HEALTHY_DATA.BLOOD_SUGAR_LIST,
			method: "get",
			setState: this.setBloodSugarList,
			data,
		});
	};
}
